<template>
    <div class="pa-1">
        <v-card v-if="dLoading" flat class="transparent">
            <v-skeleton-loader type="list-item" class="ml-4 mb-2"></v-skeleton-loader>
            <v-skeleton-loader type="list-item" class="ml-8 mb-2"></v-skeleton-loader>
            <v-skeleton-loader type="list-item" class="ml-4 mb-2"></v-skeleton-loader>
            <v-skeleton-loader type="list-item" class="ml-8 mb-2"></v-skeleton-loader>
        </v-card>
        <v-treeview v-else-if="dTree && dTree.length > 0" :items="dTree" activatable dense hoverable rounded transition>
            <template v-slot:prepend="{item}">
                <v-icon v-if="item.file" left :color="item.nMatriculaCerrada===1 ? 'red':'blue'" :title="item.nMatriculaCerrada===1 ? 'Matricula Cerrada':''">
                    {{ item.file }}
                </v-icon>
            </template>
            <template slot="label" slot-scope="{ item }">
                <!-- <a @click.prevent="fuAlumnoList(item.id)" :title="item.id" :class="[item.Concluyo=='1' ? 'red--text':'']">{{ item.name }} <v-icon small v-if="item.especial" left color="purple">star</v-icon></a> -->
                <a @click.prevent="fuIdSeccion(item.id)" :title="item.Concluyo=='1' ? 'Seccion Cerrada':''" :class="[item.Concluyo=='1' ? 'red--text':'']">
                    {{ item.name }} 
                    <v-icon small v-if="item.especial" left color="purple">star</v-icon>
                </a>
            </template>
        </v-treeview>
    </div>
</template>
<script>
import gql from 'graphql-tag';
import { fuMesNombreShort, fuTurnoIcono, fuCopy} from '@/helpers/index.js';
export default {
    name: 'MatSeccionTree',
    data: () => ({
        dLoading : false,
        dTree: [],
    }),
    methods: {
        async fumatperiodoByIdServicioByAnioByPeriodo(pIdServicio, pAnio, pPeriodo){
            this.dLoading = true;
            const response = await this.$apollo.query({
                query: gql`
                    query consulta($IdServicio: Int!, $Anio: Int!, $Periodo: Int!){
                        matperiodoByIdServicioByAnioByPeriodo(IdServicio:$IdServicio,Anio:$Anio,Periodo:$Periodo){
                            Anio
                            Periodo
                            Nivel
                            matseccions{
                                IdSeccion
                                Seccion
                                FechaInicio
                                FechaFin
                                Turno
                                HoraTurno
                                Concluyo
                                nMatriculaCerrada
                                especial
                            }
                            priservicio{
                                Iniciales
                            }
                        }
                    }
                `,fetchPolicy: 'no-cache',
                variables: {
                    IdServicio: pIdServicio,
                    Anio: pAnio,
                    Periodo: pPeriodo,
                }
            });
            this.fuTreeConvert(response.data.matperiodoByIdServicioByAnioByPeriodo);
            this.dLoading = false;
        },
        fuTreeConvert(vArray){
            this.dTree=[];
            var vArrayNew=[];
            var vArrayNew2=[];

            for(const item of vArray){
                let vIndex = vArrayNew.findIndex(el => el.id == item.Nivel );
                
                if (vIndex <0) {
                    const newObj = { id: item.Nivel, name: 'Nivel '+item.Nivel, children: [] };
                    vIndex = vArrayNew.push(newObj) -1;
                }
                for(const item2 of item.matseccions){
                    let vFechaInicio = fuMesNombreShort(parseInt(item2.FechaInicio.substring(5,7)))+" "+parseInt(item2.FechaInicio.substring(8,10));
                    let vSeccion = item.Nivel+item2.Seccion+' '+vFechaInicio;
                    var vTurno = fuTurnoIcono(item2.Turno);

                    const newObj = { id: item2.IdSeccion, name: vSeccion, file: vTurno, Seccion: item2.Seccion, nMatriculaCerrada: item2.nMatriculaCerrada, Concluyo: item2.Concluyo, especial: item2.especial};
                    vArrayNew[vIndex].children.push(newObj);
                    vArrayNew[vIndex].children.sort((p1, p2) => (p1.Seccion < p2.Seccion) ? -1 : (p1.Seccion > p2.Seccion) ? 1 : 0);

                    const newObj2 = { IdSeccion: item2.IdSeccion, Seccion: item2.Seccion, Turno: item2.Turno, FechaInicio: item2.FechaInicio, FechaFin: item2.FechaFin, nMatriculaCerrada:item2.nMatriculaCerrada, Anio: item.Anio, Periodo: item.Periodo, Nivel: item.Nivel, Iniciales: item.priservicio.Iniciales, especial: item2.especial};
                    vArrayNew2.push(newObj2);
                }
            }
            vArrayNew.sort((p1, p2) => (p1.id < p2.id) ? -1 : (p1.id > p2.id) ? 1 : 0);
            this.dTree = vArrayNew;
            // this.dMatSecciones = vArrayNew2;
        },
        fuIdSeccion(p_IdSeccion) {
            if(p_IdSeccion>50){
                fuCopy(p_IdSeccion);
                this.$emit('pIdSeccion', p_IdSeccion);
            }
        },
    }
}
</script>
